import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import PageLayout from "../layout";

const tabs = [
  { label: "Equities", to: "/data-coverage", end: true },
  { label: "Crypto/Forex", to: "/data-coverage/crypto" },
  { label: "Indices", to: "/data-coverage/indices" },
  { label: "Funds", to: "/data-coverage/funds" },
  { label: "Commodities", to: "/data-coverage/commodities" },
];

const legend = [
  { key: "Y", label: "Sourced Directly", color: "bg-green-100 text-green-800" },
  { key: "A", label: "Available via Partner", color: "bg-blue-100 text-blue-800" },
  { key: "N", label: "Not Available", color: "bg-red-100 text-red-700" },
  { key: "N/A", label: "Not Applicable", color: "bg-gray-100 text-gray-500" },
];

export default function DataCoverageLayout({ children }: { children: ReactNode }) {
  return (
    <PageLayout title="Data Coverage">
      <section className="max-w-6xl mx-auto px-6 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-1">Data Coverage</h1>
        <p className="text-gray-500 text-sm mb-6">Data availability by exchange</p>

        <div className="mb-6">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2">Legend</p>
          <div className="flex flex-wrap gap-2">
            {legend.map(({ key, label, color }) => (
              <span key={key} className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium ${color}`}>
                <span className="font-bold">{key}</span>
                <span className="opacity-75">—</span>
                {label}
              </span>
            ))}
          </div>
        </div>

        <div className="flex gap-1 border-b border-gray-200 mb-6">
          {tabs.map(({ label, to, end }) => (
            <NavLink
              key={to}
              end={end}
              to={to}
              className={({ isActive }) =>
                `px-4 py-2.5 text-sm font-medium transition-colors border-b-2 -mb-px ${
                  isActive
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-800 hover:border-gray-300"
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>

        {children}
      </section>
    </PageLayout>
  );
}
